// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a.button.multilink{margin-bottom:1em;margin-right:1.48em;padding:0 1em}.heading{font-size:14px;font-weight:700;padding-bottom:1.2em;text-transform:uppercase}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
